import { makeStyles } from "@material-ui/core/styles";
import {COLORS} from "../config/theme/baseTheme";

export const useStyles = makeStyles((theme) => ({
  downloadInvoice:{
    paddingTop: "8px", 
    backgroundColor: COLORS.GREY_OPAQUE,
  },
  closeModalIcon: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    paddingRight: "48px"
},
  invoiceModalBody: {
    borderRadius: "8px",
    '& .react-pdf__Page': {
        marginTop: "56px",
        '& .react-pdf__Page__canvas': {
            margin: "0 auto",
            height: "100% !important",
            overflow: "auto",
            minWidth: "1064px"
        },
    },
    '& .react-pdf__Page__annotations.annotationLayer': {
        padding: "8px",
    },
},
noPdfModal: {
  border: "none",
  minWidth: "800px",
  minHeight: "500px",
  maxHeight: "890px",
  backgroundColor: COLORS.SECONDARY_LIGHT,
  position: "absolute",
  top: "40%",
  left: "50%",
  transform: "translate(-40%, -50%)",
  padding: "24px",
  textAlign: "center",
  borderRadius: "8px",
},
  pdfDocStyle: {
    overflow: "scroll",
    height: "890px",
  },
  pdfHeader: {
    position: "absolute",
    backgroundColor: "#393939",
    height: "56px",
    width: "100%",
    zIndex: 1,
  },
  pdfRoot: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  zoomOutStyle: {
    marginRight: "10px",
    cursor: "pointer",
    marginTop: "20px",
  },
  zoomInStyle: {
    cursor: "pointer",
    marginTop: "12px",
    marginLeft: "16px",
  },
  pdfName: {
    fontSize: 14,
    fontWeight: 600,
    color: COLORS.WHITE,
    lineHeight: "17px",
    display: "flex",
    alignContent: "center",
    alignItems: "center",
  },
  pdfScaleNo: {
    backgroundColor: "#000408",
    width: "44px",
    height: "24px",
    padding: "6px",
    color: "white",
  },
  closeNoPdfModalIcon: {
    top: "0px",
    position: "absolute",
    right: "-12px",
    width: "40px",
    height: "40px",
    zIndex: 1,
    cursor: "pointer",
  },
noInvoiceMsg: {
    fontSize: "18px",
    fontWeight: 500,
    marginTop: "24px"
},
closeButton: {
  position: 'absolute',
  right: "12px",
  top: "12px",
  color: theme.palette.primary.main
},
}));

export default useStyles;
